/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { SubscriptionUserListViewModel } from "../models/subscription-user-list-view-model";
import { SubUsers } from "../models/sub-users";
@Injectable({
  providedIn: "root",
})
class SubscriptionUsersService extends __BaseService {
  static readonly subscriptionUsersGetSubscriptionUsersPath =
    "/api/admin/subscription/SubscriptionUsers/GetSubscriptionUsers";
  static readonly subscriptionUsersGetSubUsersAllPath =
    "/api/admin/subscription/SubscriptionUsers";
  static readonly subscriptionUsersPostSubUsersPath =
    "/api/admin/subscription/SubscriptionUsers";
  static readonly subscriptionUsersGetSubUsersPath =
    "/api/admin/subscription/SubscriptionUsers/{id}";
  static readonly subscriptionUsersPutSubUsersPath =
    "/api/admin/subscription/SubscriptionUsers/{id}";
  static readonly subscriptionUsersDeleteSubUsersPath =
    "/api/admin/subscription/SubscriptionUsers/{id}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  subscriptionUsersGetSubscriptionUsersResponse(): __Observable<
    __StrictHttpResponse<Array<SubscriptionUserListViewModel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/subscription/SubscriptionUsers/GetSubscriptionUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubscriptionUserListViewModel>>;
      })
    );
  }
  subscriptionUsersGetSubscriptionUsers(): __Observable<
    Array<SubscriptionUserListViewModel>
  > {
    return this.subscriptionUsersGetSubscriptionUsersResponse().pipe(
      __map((_r) => _r.body as Array<SubscriptionUserListViewModel>)
    );
  }
  subscriptionUsersGetSubUsersAllResponse(): __Observable<
    __StrictHttpResponse<Array<SubUsers>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/SubscriptionUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubUsers>>;
      })
    );
  }
  subscriptionUsersGetSubUsersAll(): __Observable<Array<SubUsers>> {
    return this.subscriptionUsersGetSubUsersAllResponse().pipe(
      __map((_r) => _r.body as Array<SubUsers>)
    );
  }

  /**
   * @param subUsers undefined
   */
  subscriptionUsersPostSubUsersResponse(
    subUsers: SubUsers
  ): __Observable<__StrictHttpResponse<SubUsers>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subUsers;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/subscription/SubscriptionUsers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubUsers>;
      })
    );
  }
  /**
   * @param subUsers undefined
   */
  subscriptionUsersPostSubUsers(subUsers: SubUsers): __Observable<SubUsers> {
    return this.subscriptionUsersPostSubUsersResponse(subUsers).pipe(
      __map((_r) => _r.body as SubUsers)
    );
  }

  /**
   * @param id undefined
   */
  subscriptionUsersGetSubUsersResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubUsers>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/SubscriptionUsers/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubUsers>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subscriptionUsersGetSubUsers(id: number): __Observable<SubUsers> {
    return this.subscriptionUsersGetSubUsersResponse(id).pipe(
      __map((_r) => _r.body as SubUsers)
    );
  }

  /**
   * @param params The `SubscriptionUsersService.SubscriptionUsersPutSubUsersParams` containing the following parameters:
   *
   * - `subUsers`:
   *
   * - `id`:
   */
  subscriptionUsersPutSubUsersResponse(
    params: SubscriptionUsersService.SubscriptionUsersPutSubUsersParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.subUsers;

    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/admin/subscription/SubscriptionUsers/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SubscriptionUsersService.SubscriptionUsersPutSubUsersParams` containing the following parameters:
   *
   * - `subUsers`:
   *
   * - `id`:
   */
  subscriptionUsersPutSubUsers(
    params: SubscriptionUsersService.SubscriptionUsersPutSubUsersParams
  ): __Observable<Blob> {
    return this.subscriptionUsersPutSubUsersResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  subscriptionUsersDeleteSubUsersResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubUsers>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/admin/subscription/SubscriptionUsers/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubUsers>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subscriptionUsersDeleteSubUsers(id: number): __Observable<SubUsers> {
    return this.subscriptionUsersDeleteSubUsersResponse(id).pipe(
      __map((_r) => _r.body as SubUsers)
    );
  }
}

module SubscriptionUsersService {
  /**
   * Parameters for SubscriptionUsersPutSubUsers
   */
  export interface SubscriptionUsersPutSubUsersParams {
    subUsers: SubUsers;
    id: number;
  }
}

export { SubscriptionUsersService };
